export default function CardIcon() {
  return (
    <svg width='34' height='24' viewBox='0 0 59 44' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M58.1074 12.4279V5.24772C58.1074 3.97819 57.6031 2.76065 56.7054 1.86295C55.8077 0.965258 54.5902 0.460938 53.3206 0.460938H5.4528C4.18327 0.460938 2.96573 0.965258 2.06803 1.86295C1.17034 2.76065 0.666016 3.97819 0.666016 5.24772V12.4279H58.1074Z'
        fill='url(#paint0_linear_28838_3522)'
      />
      <path
        d='M0.666016 17.2148V38.7554C0.666016 40.0249 1.17034 41.2424 2.06803 42.1401C2.96573 43.0378 4.18327 43.5422 5.4528 43.5422H53.3206C54.5902 43.5422 55.8077 43.0378 56.7054 42.1401C57.6031 41.2424 58.1074 40.0249 58.1074 38.7554V17.2148H0.666016ZM41.3537 38.7554H38.9603C38.3255 38.7554 37.7167 38.5032 37.2679 38.0544C36.8191 37.6055 36.5669 36.9967 36.5669 36.362C36.5669 35.7272 36.8191 35.1184 37.2679 34.6696C37.7167 34.2207 38.3255 33.9686 38.9603 33.9686H41.3537C41.9884 33.9686 42.5972 34.2207 43.0461 34.6696C43.4949 35.1184 43.7471 35.7272 43.7471 36.362C43.7471 36.9967 43.4949 37.6055 43.0461 38.0544C42.5972 38.5032 41.9884 38.7554 41.3537 38.7554ZM50.9272 38.7554H48.5339C47.8991 38.7554 47.2903 38.5032 46.8415 38.0544C46.3926 37.6055 46.1405 36.9967 46.1405 36.362C46.1405 35.7272 46.3926 35.1184 46.8415 34.6696C47.2903 34.2207 47.8991 33.9686 48.5339 33.9686H50.9272C51.562 33.9686 52.1708 34.2207 52.6196 34.6696C53.0685 35.1184 53.3206 35.7272 53.3206 36.362C53.3206 36.9967 53.0685 37.6055 52.6196 38.0544C52.1708 38.5032 51.562 38.7554 50.9272 38.7554Z'
        fill='url(#paint1_linear_28838_3522)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_28838_3522'
          x1='0.666016'
          y1='12.4279'
          x2='58.1'
          y2='12.4632'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#C71CB8' />
          <stop offset='1' stop-color='#FE139C' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_28838_3522'
          x1='0.666016'
          y1='43.5422'
          x2='58.1001'
          y2='43.5582'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#C71CB8' />
          <stop offset='1' stop-color='#FE139C' />
        </linearGradient>
      </defs>
    </svg>
  )
}
